var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.375C14.0625 3.375 10.125 3.9375 10.125 3.9375V9C10.125 12.2597 12.1996 16.078 13.9471 18.7196C10.58 16.9797 6.1875 13.1625 6.1875 9.5625V7.875H8.40344L7.77942 5.625H3.9375V9.5625C3.9375 15.7213 12.319 21.3293 16.2719 21.8881C16.2763 21.8933 16.3125 21.9375 16.3125 21.9375V25.0983C16.7794 24.9858 17.2916 24.8962 17.8429 24.8456C18.5123 24.7837 19.125 24.7786 19.6875 24.8236V21.9375C19.6875 21.9375 19.7237 21.8933 19.7282 21.8881C23.681 21.3293 32.0625 15.7213 32.0625 9.5625V5.625H28.2206L27.5966 7.875H29.8125V9.5625C29.8125 13.1625 25.42 16.9797 22.0529 18.7196C23.8004 16.078 25.875 12.2597 25.875 9V3.9375C25.875 3.9375 21.9375 3.375 18 3.375ZM18 26.4375C15.1875 26.4375 13.5 27.5625 13.5 27.5625L12.375 30.9375L12.1827 31.0342C11.6112 31.3199 11.25 31.9036 11.25 32.5426V33.1875H24.75V32.5426C24.75 31.9036 24.3888 31.3199 23.8173 31.0342L23.625 30.9375L22.5 27.5625C22.5 27.5625 20.8125 26.4375 18 26.4375Z",
    fill: "url(#paint0_linear_12024_13609)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12024_13609",
    x1: 4.13556,
    y1: 3.375,
    x2: 32.0714,
    y2: 3.83198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#5BFFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADC9F"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContest);
export default __webpack_public_path__ + "static/media/contest.132273cffd40d3e3e3c5010e7fd86517.svg";
export { ForwardRef as ReactComponent };